import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';

export const deepCamelcaseKeys = (value: any) => camelcaseKeys(value, { deep: true });
export const deepSnakecaseKeys = (value: any) => snakecaseKeys(value, { deep: true });
